import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import clsx from 'clsx';
import prismjs from 'prismjs';
import { useState } from 'react';
import { FrameHeader, Icon } from '@/components';
import { getPrismLanguage } from '@/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Frame = ({
  frame,
  type
}) => {
  const [showOriginal, setShowOriginal] = useState(!!frame.orgSourceFragment);
  const sourceFragment = showOriginal ? frame.orgSourceFragment : frame.sourceFragment;
  const hasFragment = Array.isArray(sourceFragment) && sourceFragment.length > 0;
  const {
    grammar,
    language
  } = getPrismLanguage(frame.orgFileName || frame.fileName);
  return /*#__PURE__*/_jsxs("div", {
    className: "ima-frame",
    children: [/*#__PURE__*/_jsx(FrameHeader, {
      frame: frame,
      isCompile: type === 'compile',
      onToggle: () => setShowOriginal(!showOriginal),
      showOriginal: showOriginal,
      hasFragment: hasFragment
    }), /*#__PURE__*/_jsx("div", {
      className: "ima-frame__code",
      children: hasFragment ? /*#__PURE__*/_jsx("pre", {
        children: /*#__PURE__*/_jsx("code", {
          children: sourceFragment.map(line => /*#__PURE__*/_jsxs("div", {
            className: clsx('ima-frame__line', {
              'ima-frame__line--highlight': line.highlight
            }),
            children: [/*#__PURE__*/_jsx("div", {
              className: "ima-frame__line-number",
              children: line.line
            }), /*#__PURE__*/_jsx("div", {
              dangerouslySetInnerHTML: {
                __html: prismjs.highlight(line.source, grammar, language)
              }
            })]
          }, `${line.line}${line.source}`))
        })
      }) : /*#__PURE__*/_jsxs("div", {
        className: "ima-frame__error",
        children: [/*#__PURE__*/_jsx(Icon, {
          icon: "alert",
          size: "xs",
          className: "ima-frame__error-icon"
        }), ' ', "Original source fragment is not available."]
      })
    })]
  });
};
export default Frame;